<template>
  <div @click="handleClickInternal()" class="component_2">
    <h1>{{ msg }} {{ numClicks }}</h1>
    <br>
    <!-- <p v-if="docs">{{ this.docs[1] + '/' + this.docs[2] + '/' + this.docs[3]}}</p> -->
    <router-link v-if="docs" :to="'/docs/' + this.docs[1] + '/' + this.docs[2] + '/' + this.docs[3]">{{this.docs[3]}}</router-link>
  </div>
</template>

<script>
import EventBus from '../eventBus'
import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'Component2',
  created () {
    this.get_docs()
  },
  data () {
    return {
      msg: 'Component 2',
      numClicks: 0
    }
  },
  methods: {
    ...mapActions([
      'get_docs'
    ]),
    handleClickInternal () {
      this.numClicks++
      EventBus.$emit('component_2_clicked', this.numClicks)
    }
  },
  computed: {
    ...mapGetters([
      'docs'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.component_2{
  background-color: white;
}
h1, h2 {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Component2.vue